<template>
  <div id="app" v-if="is_pc" style="background: white">
    <div style="min-height: 900px;">
      <router-view/>
    </div>
    <div class="footer" style="position:absolute;z-index:120;" v-html="systemFooter()"></div>
  </div>

</template>

<script>
window.addEventListener('beforeunload', e => {
  window.scrollTo(0, 0)
})
export default {
  name: 'App',
  data () {
    return {
      is_pc: true
    }
  },
  created () {
    // document.title = this.$route.meta.title
    this.$store.commit('updateNavRouter', this.$route.name)
    if (this._isMobile()) {
      this.is_pc = true
    } else {
      this.is_pc = true
    }
  },
  watch: {
    $route: function (route) {
      window.scrollTo(0, 0)
      // document.title = this.$route.meta.title
      this.$store.commit('updateNavRouter', this.$route.name)
    }
  },

  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    systemFooter () {
      switch (location.hostname.split('.')[0]) {
        case 'nmlztest': // 内蒙系统
          return `<div>
                    <p class="footer-item">
                      <span>版权所有：内蒙古自治区市场监督管理局</span>
                      <span style="margin-left: 16px">蒙ICP备13000946号</span>
                    </p>
                    <p class="footer-item">
                      <span>地址：呼和浩特市金桥开发区 内蒙古工商行政管理信息中心</span>
                      <span style="margin-left: 16px">邮编：010018</span>
                    </p>
                    <p class="footer-item"><span>建议使用1024*768分辨率，IE8.0以上浏览 </span></p>
                    <p class="footer-item"><span>技术支持：上海凭安征信服务有限公司</span></p>
                  </div>`
        default:
          return `<div>
                    <span>建议使用1024*768分辨率，IE8.0以上浏览</span><br/>
                    <span>技术支持：上海凭安征信服务有限公司</span><br/>
                  </div>`
      }
    }
  }
}
</script>

<style>
#app {
  font: 12px/1.5 system, -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "PingFang SC", "Segoe UI", "Microsoft YaHei", "wenquanyi micro hei", "Hiragino Sans GB", "Hiragino Sans GB W3", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", Arial, sans-serif;
  word-wrap: break-word;
  word-break: break-word;
}

* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
}

body {
  background: #eee;
}

ul,
li {
  list-style-type: none
}

a {
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

img {
  border: none;
  vertical-align: middle;
}

.no-data {
  width: 300px;
  text-align: center;
  height: 21px;
  line-height: 21px;
  margin: 0 auto;
  color: #878787;
  font-size: 14px;
  margin-top: 360px;
}

.container {
  width: 1200px;
  min-height: 810px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 10px;
  padding-top: 20px;
}

.container .content {
  min-height: 810px;
  width: calc(100% - 100px);
  margin: 0 auto;
}

.content .title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: #878787;
  text-align: left;
  overflow: hidden;
  /* 超出隐藏结合width使用截取采用效果*/
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.content .title > a:hover {
  color: #000000 !important;
}

.content .title a {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: #878787;
  text-align: left;
}

.title-line {
  width: calc(100% + 60px);
  margin-left: -30px;
  border-bottom: 1px solid #C4C4C4;
}

.el-header {
  padding: 0;
  margin: 0;
}

.btn {
  display: inline-block;
  text-align: center;
  padding: 10px 0;
  width: 110px;
  color: #fff;
  font-size: 14px;
  border-radius: 3px;
  border: none 0;
  cursor: pointer;
  line-height: normal;
  outline: 0;
  white-space: nowrap;
}

.btn:hover {
  color: #fff;
  background: #3d74cf;

}

.footer {
  margin: 0 auto;
  width: 100%;
  height: 80px;
  background-color: #FFFFFF;
  color: #878787;
  padding-top: 0px;
  line-height: 25px;
  text-align: center;
  font-size: 16px;
  margin-top: -20px;
}

.footer > a {
  color: #878787;
  font-size: 13px;
}

@media all and (min-height: 640px) and (max-height: 800px) {

  .answer-content {
    zoom: 0.9;
    -moz-transform: scale(0.9, 0.9);
    -moz-transform-origin: 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue